import React from 'react';
import { PdfContainer, PdfWrapper, BackButton } from './PdfViewerElements';
import { useHistory, useLocation } from 'react-router-dom';

const PdfViewer = () => {
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const pdfPath = queryParams.get('pdf');
    const title = queryParams.get('title') || 'Document';

    const handleGoBack = () => {
        history.goBack();
    };

    if (!pdfPath) {
        return (
            <PdfContainer>
                <PdfWrapper>
                    <h2>No PDF specified</h2>
                    <BackButton onClick={handleGoBack}>Go Back</BackButton>
                </PdfWrapper>
            </PdfContainer>
        );
    }

    return (
        <PdfContainer>
            <PdfWrapper>
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: '20px',
                    padding: '0 20px'
                }}>
                    <h2 style={{ color: '#2d3748', margin: 0 }}>{title}</h2>
                    <BackButton onClick={handleGoBack}>← Go Back</BackButton>
                </div>
                <iframe
                    src={pdfPath}
                    width="100%"
                    height="100%"
                    style={{
                        border: 'none',
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
                    }}
                    title={title}
                />
            </PdfWrapper>
        </PdfContainer>
    );
};

export default PdfViewer;
